import React, { Component } from "react";
import ModalWrapper, { withOnClose } from "../ModalWrapper";
import Translator from "src/requests/apa/Translator";
import { Button } from "packages/components";
import './styles.scss'
import { autobind } from "packages/core/lib";
import store from "src/store";
import { HIDE_MODAL } from "src/actions/modal";
import { removeDynamicFocus } from "src/components/Focus/utils";
import { AYUDACONFIRMACION, MODALAYUDACONFIRMACION, ACEPTAR } from '../../../AAFPlayer/constants';
import {GA4} from '../../../utils/trackers/GA4';
import Utils from '../../../utils/Utils';

interface IProps {
    callbackWhenBack: () => void;
    dataMetrics2FA: any;
    history: { location: { pathname: string } };
}

class Help2FA extends Component<IProps> {
  device: string;
  getParamsMetrics2FA: any;

  constructor(props: IProps){
    super(props);
    this.getParamsMetrics2FA = Utils.getParamsMetricsModals2FA(props.dataMetrics2FA, AYUDACONFIRMACION , props.history.location.pathname, MODALAYUDACONFIRMACION);
  }

  componentDidMount(): void {
    removeDynamicFocus();
  }

  sendGA4Metric(){
    const gA4 = new GA4();
    gA4.sendMetrics2FA(this.getParamsMetrics2FA, ACEPTAR);
  }
    
  @autobind
  handleClick() {
    this.sendGA4Metric();
    this.props.callbackWhenBack()
    store.dispatch({
        type: HIDE_MODAL
    })
  }

  render() {
    return (
      <ModalWrapper callbackWhenBack={this.handleClick}>
        <div className='FullHD help-2fa'>
          <h1>{Translator.get('Alerta_2FATelmex_Ayuda_TextoTitulo')}</h1>
          <p className="problem-text">
            {Translator.get('Alerta_2FATelmex_Ayuda_TextoMensaje1_Parte1')}
            <span> {Translator.get('Alerta_2FATelmex_Ayuda_TextoMensaje1_Parte2')}</span>
          </p>

          <p className="contact-text">
            {Translator.get('Alerta_2FATelmex_Ayuda_TextoMensaje2_Parte1')}
            <span> {Translator.get('Alerta_2FATelmex_Ayuda_TextoMensaje2_Parte2')} </span>
             {Translator.get('Alerta_2FATelmex_Ayuda_TextoMensaje2_Parte3')}
          </p>
        
            <div>
                <Button
                    type="button"
                    className="btn focusable"
                    onClick={this.handleClick}
                >
                    <p>{Translator.get('Alerta_2FATelmex_TextoBotonPrimario_Aceptar')}</p>
                </Button>
            </div>
        
            
            <h2>{Translator.get('Alerta_2FATelmex_TextoTituloAyuda')}</h2>
            <p className="help-text">{Translator.get('Alerta_2FATelmex_Ayuda_TextoAyuda1')}</p>
        </div>
       
      </ModalWrapper>
    )
  }
}


export default withOnClose(Help2FA);



// WEBPACK FOOTER //
// ./src/components/Modal/Help2FA/Help2FA.tsx